import React, { PropTypes } from 'react';
import { reduxForm, Field, SubmissionError, formValueSelector } from 'redux-form';
import TextareaControl from '../../FormTemplate/TextareaControl';
import SelectAsync from '../../FormTemplate/SelectAsync';
import Select from '../../FormTemplate/Select';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import axios from './../../../constants/axios';
import alert from 'alertify.js';

@reduxForm({
   form: 'contactAddressNewForm',
   initialValues: {
      contact_address_type_id: 2 // Resident
   }
})
class ContactAddressNewForm extends React.Component {

   constructor(props) {
      super(props);
      this.state = {
         thanas: [],
         addressTypes: []
      };
   }

   componentDidMount() {
      axios.get('contacts/getContactAddressTypes')
         .then((res) => {
            let n = res.data.map(function (i) {
               return {
                  label: i.name,
                  value: i.id
               };
            });
            this.setState({
               addressTypes: n
            });
         });
   }

   componentWillReceiveProps(nextProps, oldProps) {
      if (nextProps.districtId === null) {
         this.setState({
            thanas: []
         });
      } else {
         if (nextProps.districtId !== oldProps.districtId) {
            axios.get(`districts/${nextProps.districtId}/thanas/getThanasByDistrictId`)
               .then((res) => {
                  let n = res.data.map(function (i) {
                     return {
                        label: i.name,
                        value: i.id
                     };
                  });
                  this.setState({
                     thanas: n
                  });
               });
         }
      }
   }

   save = (inputs) => {
      const { contactId, toggleShowForm } = this.props;
      return axios.post(`contacts/${contactId}/address`, inputs)
         .then((res) => {
            if (res.status === 201) {
               alert.success('Create Successful.');
               toggleShowForm();
            } else {
               alert.error('UnExpected error. Call Admin.');
            }
         })
         .catch((err) => {
            if (err.response.status === 422) {
               throw new SubmissionError(err.response.data);
            } else {
               alert.error('UnExpected error. Call Admin.');
            }
         });
   };

   render() {
      const { handleSubmit, submitting, pristine, invalid, toggleShowForm } = this.props;
      const { thanas, addressTypes } = this.state;
      return (
         <div>
            <h4>Create New Contact Address</h4>
            <hr/>
            <form noValidate autoComplete="off" onSubmit={handleSubmit(this.save)} >
               <Field name="address" component={TextareaControl} label="Address" />
               <Field name="district_id" component={SelectAsync} link="/districts/searchByName" label="District" />
               <Field name="thana_id" component={Select} allowEmpty={true} options={thanas} label="Thana" />
               <Field name="contact_address_type_id" component={Select} options={addressTypes} label="Contact Type" />


               <Button type="submit" bsStyle="success"
                       disabled={submitting || pristine || invalid} >Save</Button>
               <Button bsStyle="warning" onClick={toggleShowForm} >Cancel</Button>
            </form>
         </div>
      );
   }
}
ContactAddressNewForm.propTypes = {
   handleSubmit: PropTypes.func,
   params: PropTypes.object,
   general: PropTypes.object,
   submitting: PropTypes.bool,
   pristine: PropTypes.bool,
   invalid: PropTypes.bool,
   dispatch: PropTypes.func,
   toggleShowForm: PropTypes.func,
   contactId: PropTypes.string
};

const selector = formValueSelector('contactAddressNewForm');
ContactAddressNewForm = connect(state => { // eslint-disable-line
   const districtId = selector(state, 'district_id');
   return {
      districtId
   };
})(ContactAddressNewForm);

export default ContactAddressNewForm;



/** WEBPACK FOOTER **
 ** ./src/components/Contact/ContactDetail/ContactAddressNewForm.js
 **/